<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado
        :elementos="encabezado"
        :nameRoute="nameRoute"
        v-if="showAction(1)"
      />
      <v-card v-if="showAction(1)" class="pt-5">
        <div name="calendar">
          <div>
            <v-row>
              <v-col>
                <v-sheet class="m-15">
                  <div name="table">
                    <v-data-table
                      :headers="headers"
                      :items="list"
                      :search="search"
                      :items-per-page="10"
                      :footer-props="{
                        'items-per-page-text': 'Elementos por página',
                        'items-per-page-all-text': 'Todo',
                      }"
                      no-results-text="Sin resultados coincidentes con el búsqueda"
                      loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles"
                      class="mx-5"
                      dense
                      fixed-header
                      height="auto"
                    >
                      <template v-slot:top>
                        <v-row align="baseline" justify="center" class="row">
                          <branch-offices-list
                            :classOfDiv="cols"
                            v-on:triggerChange="branchOfficeSelected"
                            :model="idBranchOfficeSelected"
                          />

                          <v-col>
                            <v-text-field
                              v-model="search"
                              append-icon="mdi-magnify"
                              label="Buscar"
                              single-line
                            />
                          </v-col>
                        </v-row>
                      </template>

                      <template v-slot:[`item.counter`]="{ index }">
                        {{ index + 1 }}
                      </template>
                      <template v-slot:[`item.status`]="{ item }">
                        <div
                          :class="`${item.color}`"
                          :style="`background-color:${item.color}`"
                          class="text-center rounded-xl"
                        >
                          <span class="white--text">{{ item.status }}</span>
                        </div>
                      </template>
                      <template v-slot:[`item.actions`]="{ item, index }">
                        <v-tooltip
                          top
                          v-if="
                            (item.appointmentStatus == 1 ||
                              item.appointmentStatus == 2 ||
                              item.appointmentStatus == 5) &&
                            $utilFront.withPermission(
                              $prm.NOTIFICATION_SCHEDULE
                            )
                          "
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              @click="notificarLlegada(item, index)"
                              color="red lighten-2"
                            >
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-bell
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Notificar</span>
                        </v-tooltip>

                        <span
                          v-if="
                            (item.appointmentStatus == 1 ||
                              item.appointmentStatus == 2 ||
                              item.appointmentStatus == 5) &&
                            !$utilFront.withPermission(
                              $prm.NOTIFICATION_SCHEDULE
                            )
                          "
                        >
                          - - -
                        </span>

                        <v-tooltip
                          top
                          v-if="
                            item.appointmentStatus == 6 &&
                            $utilFront.withPermission($prm.ADD_VITAL_SIGNS)
                          "
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small icon @click="vitalSigns(item, index)">
                              <v-icon v-bind="attrs" v-on="on" color="teal">
                                mdi-book-edit
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Signos vitales</span>
                        </v-tooltip>

                        <span
                          v-if="
                            item.appointmentStatus == 6 &&
                            !$utilFront.withPermission($prm.ADD_VITAL_SIGNS)
                          "
                        >
                          - - -
                        </span>

                        <v-tooltip
                          top
                          v-if="
                            $utilFront.withPermission(
                              $prm.MODULE_CONSULTATION_CANCEL
                            )
                          "
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              @click="checkCancel(item)"
                              :disabled="sending"
                            >
                              <v-icon color="error" v-bind="attrs" v-on="on">
                                mdi-stop
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Cancelar toma de signos</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div class="mt-10 mb-10" />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
      <encabezado
        :elementos="encabezado"
        :nameRoute="nameRoute"
        v-if="showAction(2) || showAction(3)"
      />
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form lazy-validation v-model="valid" @submit.prevent="saveData">
            <v-card-text>
              <div class="container">
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black mb-5">
                      <h5 class="font-gray mb-5 mt-5">
                        {{ selectedEvent.specialtyNames }}
                      </h5>
                    </h3>
                  </v-col>
                  <v-col md="2">
                    <h3 class="font-weight-black mb-5">
                      Id Paciente
                      <span class="error--text">{{ patient.idPatient }}</span>
                    </h3>
                  </v-col>
                </v-row>

                <v-row justify="space-around">
                  <v-col cols="12" md="12" sm="12">
                    <patient-information :model="patient" @patientLoaded="onPatientLoaded"  />
                  </v-col>
                </v-row>
              </div>

              <v-container>
                <v-expansion-panels class="mt-5 mb-10" v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <v-row dense class="text-left">
                        <v-col cols="12" sm="12" md="12">
                          <v-banner
                            color="blue-grey lighten-5"
                            class="br black--text"
                            shaped
                            single-line
                            dense
                            align="left"
                          >
                            <v-icon class="mr-2">mdi-stethoscope</v-icon>
                            Signos vitales
                          </v-banner>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-container>
                        <!-- <v-form
                        lazy-validation
                        v-model="valid"
                        @submit.prevent="validate(saveData)"
                      > -->
                        <div class="row">
                          <div
                            class="col-md-4"
                            v-for="(input, index) in inputsVitalSign"
                            :key="index"
                          >
                            <validation-provider
                              v-slot="{ errors }"
                              :rules="checkTypetoAssignValidation(input)"
                              :name="input.label"
                            >
                              <v-text-field
                                v-model="vitalSign[`${input.idVitalSignType}`]"
                                :label="input.label"
                                :suffix="input.suffix"
                                :type="input.type"
                                min="1"
                                :error-messages="errors"
                                @change="calculateIMC()"
                                required
                                :key="updater"
                                dense
                              ></v-text-field>
                            </validation-provider>
                          </div>
                        </div>
                        <!-- </v-form> -->
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

  <div v-if="filteredCalculators.length > 0">
    <v-expansion-panels class="mt-5 mb-10" v-model="panelDiabetes">
      <v-expansion-panel
        v-for="(calculator, index) in filteredCalculators"
        :key="index"
      >
        <v-expansion-panel-header>
          <v-row dense class="text-left">
            <v-col cols="12">
              <v-banner
                color="blue-grey lighten-5"
                class="br black--text"
                shaped
                single-line
                dense
                align="left"
              >
                <v-icon class="mr-2">mdi-diabetes</v-icon>
                {{ calculator.name }}
              </v-banner>
            </v-col>
          </v-row>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-container>
            <v-row>
              <!-- Sección de preguntas -->
              <v-col
                v-for="question in calculator.dataQuestions"
                :key="question.idQuestion"
                cols="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: question.required }"
                  :name="question.name"
                >
                  <v-autocomplete
                    v-if="question.typeAnswer === 2"
                    v-model="question.answerClosed"
                    :items="question.answers"
                    item-value="idAnswer"
                    item-text="name"
                    :label="question.name"
                    clearable
                    :error-messages="errors"
                    dense
                    @change="updateModal(question)"
                    :disabled="isViewDetailsForm"
                  ></v-autocomplete>

                  <v-text-field
                    v-else-if="question.typeAnswer === 1"
                    v-model="question.answerOpen"
                    :label="question.name"
                    dense
                    :error-messages="errors"
                    :disabled="isViewDetailsForm"
                  ></v-text-field>
                </validation-provider>
              </v-col>

              <!-- Findrisc (ETEL-01) -->
              <v-col
                cols="12"
                md="7"
                v-if="calculator.idCalculator === 'ETEL-01'"
              >
                <v-data-table
                  hide-default-footer
                  :items="interpretation"
                  :headers="headersDiabetesResults"
                  class="elevation-1"
                />
              </v-col>

              <v-col
                cols="12"
                md="5"
                v-if="calculator.idCalculator === 'ETEL-01'"
              >
                <v-card outlined>
                  <v-card-title class="text-h6">
                    Interpretación:
                  </v-card-title>
                  <v-card-text>
                    <div>
                      <p>
                        <strong>Puntuación total:</strong>
                        {{ getCalculatorPoints(calculator) }}
                      </p>
                      <p>
                        <strong>Riesgo de desarrollar diabetes en 10 años:</strong>
                        {{ getRiskInterpretation(calculator).riskPercentage }}
                      </p>
                      <p>
                        <strong>Interpretación:</strong>
                        {{ getRiskInterpretation(calculator).riskInterpretation }}
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Hiperplasia (ETEL-03) -->
              <v-col
                cols="12"
                md="5"
                v-if="calculator.idCalculator === 'ETEL-03'"
              >
                <v-card outlined>
                  <v-card-title class="text-h6">
                    Valoración:
                  </v-card-title>
                  <v-card-text>
                    <div>
                      <p>
                        <strong>Puntaje total:</strong>
                        {{ getCalculatorPoints(calculator) }}
                      </p>
                      <p>
                        <strong>Sintomatología:</strong>
                        {{ getHiperplasiaInterpretation(calculator) }}
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Riesgo Cardiovascular (ETEL-02) -->
              <v-col
                cols="12"
                md="5"
                v-if="calculator.idCalculator === 'ETEL-02'"
              >
                <v-card outlined>
                  <v-card-title class="text-h6">
                    Riesgo Cardiovascular
                  </v-card-title>
                  <v-card-text>
                    <div>
                      <p>
                        <strong>Porcentaje de riesgo:</strong>
                        {{ getCardioRiskForCalculator(calculator) }}%
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

            </v-row>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>

               



                <v-expansion-panels class="mb-10" v-model="panePL" multiple>
                  <v-expansion-panel
                    v-for="(item, index) in heredoFamiliar"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      <v-row dense class="text-left">
                        <v-col cols="12" sm="12" md="12">
                          <v-banner
                            color="blue-grey lighten-5"
                            class="br black--text"
                            shaped
                            single-line
                            dense
                            align="left"
                          >
                            <v-icon class="mr-2">mdi-border-color</v-icon>
                            {{ item.name }}
                          </v-banner>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row align="baseline">
                        <v-col
                          v-for="(question, subindex) in item.questions"
                          :key="subindex"
                        >
                          <span>{{ question.name }}</span>
                          <!-- <validation-provider
                            v-slot="{ errors }"
                            :name="question.name"
                            :rules="question.required == 1 ? 'required' : ''"
                          > -->
                          <validation-provider
                            v-slot="{ errors }"
                            :name="question.name"
                            rules="required"
                          >
                            <v-radio-group
                              v-if="
                                question.typeAnswer == 2 ||
                                question.typeAnswer == 4
                              "
                              v-model="question.idAnswer"
                              :error-messages="errors"
                              :required="question.required == 1"
                            >
                              <v-radio
                                v-for="(
                                  answer, sub_subindex
                                ) in question.answers"
                                :key="sub_subindex"
                                :value="answer.idAnswer"
                                :label="answer.name"
                              />
                            </v-radio-group>

                            <v-autocomplete
                              v-if="question.typeAnswer == 3"
                              v-model="question.selectedAnswers"
                              :items="question.answers"
                              item-text="name"
                              item-value="idAnswer"
                              :error-messages="errors"
                              auto-select-first
                              chips
                              clearable
                              deletable-chips
                              multiple
                              small-chips
                              dense
                              :required="question.required == 1"
                            />

                            <v-text-field
                              v-if="
                                (question.typeAnswer == 1 ||
                                  question.typeAnswer == 4) &&
                                question.typeData != 6
                              "
                              v-model="question.answer"
                              :error-messages="errors"
                              :type="question.typeDataText"
                              :required="question.required == 1"
                              autocomplete="off"
                              dense
                              clearable
                            />

                            <v-textarea
                              v-if="
                                (question.typeAnswer == 1 ||
                                  question.typeAnswer == 4) &&
                                question.typeData == 6
                              "
                              v-model="question.answer"
                              :error-messages="errors"
                              outlined
                              dense
                              clearable
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-expansion-panels v-model="panelHF" multiple>
                  <v-expansion-panel
                    v-for="(item, index) in pathologicals"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      <v-row dense class="text-left">
                        <v-col cols="12" sm="12" md="12">
                          <v-banner
                            color="blue-grey lighten-5"
                            class="br black--text"
                            shaped
                            single-line
                            dense
                            align="left"
                          >
                            <v-icon class="mr-2">mdi-border-color</v-icon>
                            {{ item.name }}
                          </v-banner>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row align="baseline">
                        <v-col
                          v-for="(question, subindex) in item.questions"
                          :key="subindex"
                        >
                          <span>{{ question.name }}</span>
                          <!-- <validation-provider
                            v-slot="{ errors }"
                            :name="question.name"
                            :rules="question.required == 1 ? 'required' : ''"
                          > -->
                          <validation-provider
                            v-slot="{ errors }"
                            :name="question.name"
                            rules="required"
                          >
                            <v-radio-group
                              v-if="
                                question.typeAnswer == 2 ||
                                question.typeAnswer == 4
                              "
                              v-model="question.idAnswer"
                              :error-messages="errors"
                              :required="question.required == 1"
                            >
                              <v-radio
                                v-for="(
                                  answer, sub_subindex
                                ) in question.answers"
                                :key="sub_subindex"
                                :value="answer.idAnswer"
                                :label="answer.name"
                              />
                            </v-radio-group>

                            <v-autocomplete
                              v-if="question.typeAnswer == 3"
                              v-model="question.selectedAnswers"
                              :items="question.answers"
                              item-text="name"
                              item-value="idAnswer"
                              :error-messages="errors"
                              auto-select-first
                              chips
                              clearable
                              deletable-chips
                              multiple
                              small-chips
                              dense
                              :required="question.required == 1"
                            />

                            <v-text-field
                              v-if="
                                (question.typeAnswer == 1 ||
                                  question.typeAnswer == 4) &&
                                question.typeData != 6
                              "
                              v-model="question.answer"
                              :error-messages="errors"
                              :type="question.typeDataText"
                              :required="question.required == 1"
                              autocomplete="off"
                              dense
                              clearable
                            />

                            <v-textarea
                              v-if="
                                (question.typeAnswer == 1 ||
                                  question.typeAnswer == 4) &&
                                question.typeData == 6
                              "
                              v-model="question.answer"
                              :error-messages="errors"
                              outlined
                              dense
                              clearable
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

               
  <v-row 
  class="mt-5"       
  align="center"     
  justify="start"    
  dense
>
  <v-col cols="12" md="4">
    <validation-provider v-slot="{ errors }" name="¿Tiene alguna discapacidad?" rules="required">
      <v-radio-group
        v-model="patient.hasDisability"
        label="¿Tiene alguna discapacidad?"
        row
        :error-messages="errors"
      >
        <v-radio label="Sí" value="1"></v-radio>
        <v-radio label="No" value="0"></v-radio>
      </v-radio-group>
    </validation-provider>
  </v-col>

  <v-col 
  cols="12" 
  md="4" 
  v-if="patient.hasDisability === '1'"
  class="d-flex align-center"
>
  <div class="d-flex align-center">
    <span class="mr-2 grey--text text--darken-3" style="white-space: nowrap;">
      Seleccione la discapacidad:
    </span>

    <v-select
      v-model="patient.disabilityType"
      :items="disabilityOptions"
      item-text="text"
      item-value="value"
      label=""
      hide-details="auto"
      clearable
      dense
      class="mt-n2"           
      style="margin-top: -5px;" 
    />
  </div>
</v-col>


</v-row>


              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-row justify="center" align="center" class="py-4 text-center">
                <v-col>
                  <v-btn
                    type="button"
                    color="error"
                    plain
                    @click="changeAction(1)"
                    >Cancelar<v-icon right>mdi-close</v-icon>
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    type="submit"
                    class="primary"
                    :disabled="sending || invalid || !canSaveSomatometry"
                    >Guardar<v-icon right>mdi-content-save</v-icon>
                    <!-- @click="saveData()" -->
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>

      <v-dialog v-model="dialogNotification" max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Notificación de llegada
          </v-card-title>
          <v-card-text>
            <div class="container">
              <v-form lazy-validation v-model="valid">
                <div class="row d-flex justify-center">
                  <div class="col">
                    <span>Asistencia del paciente</span>
                    <v-radio-group
                      v-model="notification"
                      row
                      mandatory
                      :rules="nameRules"
                    >
                      <v-radio label="Presente" value="1"></v-radio>
                      <v-radio
                        label="Ausente"
                        value="2"
                        color="error"
                        class="error--text"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogNotification = false">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              text
              :disabled="!valid || sending"
              @click="notificarLlegadaSend()"
            >
              Notificar Llegada
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog2" persistent max-width="800" v-if="dialog2">
        <v-card>
          <validation-observer ref="formCancel" v-slot="{ invalid }">
            <v-card-title class="text-h6 text-center error--text">
              ¿Desea cancelar la solicitud?
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <patient-information :model="dataModal" />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    @click.right.prevent
                    @copy.prevent
                    @paste.prevent
                    ondrop="return false;"
                  >
                    <v-form v-model="valid" lazy-validation>
                      <validation-provider
                        v-slot="{ errors }"
                        name="Motivo de la cancelación"
                        rules="required|min:6"
                      >
                        <v-textarea
                          outlined
                          v-model="reason"
                          :value="reason"
                          label="Motivo de la cancelación"
                          id="cancellation"
                          :error-messages="errors"
                          required
                        ></v-textarea>
                      </validation-provider>
                    </v-form>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="text-center">
              <v-col>
                <v-btn color="error" plain @click="closeCancel()">
                  <v-icon left>mdi-chevron-left</v-icon> Volver
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  :disabled="sending || invalid"
                  color="primary"
                  @click="cancelConsultation()"
                >
                  Cancelar consulta <v-icon right>mdi-calendar-remove</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </validation-observer>
        </v-card>
      </v-dialog>
      <!-- Fin Dialogs -->
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar";
import AutoLogout from "@/components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { UtilFront } from "@/core/";
import BranchOfficesList from "../../components/BranchOfficesList.vue";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import cardioRiskData from "@/app/json/cardioRiskData.json"


import {
  ModuleRequest,
  AppointmentRequest,
  TypeVitalSignRequest,
  EvaluationRequest,
  VitalSignRequest,
  MedicalPracticeRequest,
  CalculatorsSomatometryRequest,
  EnumRequest,
} from "@/core/request";

export default {
  name: "Somatometria",
  components: {
    Loader,
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    AutoLogout,
    BranchOfficesList,
    PatientInformation,
  },
  data() {
    return {
      //Inicio signos vitales
      idPerson: null,
      inputsVitalSign: [],
      vitalSign: {},
      patient: null,
      appointment: null,
      pathologicals: [],
      heredoFamiliar: [],
      panelHF: [0],
      panePL: [0],
      panel: 0,
      panelDiabetes: [],
      disabledHeader: true,
      //Fin signos vitales
      //Inicio calendario
      cancelReason: "",
      idAppointment: "",
      dialogCancelDate: false,
      dialogNotification: false,
      nameRules: [(v) => !!v || "Campo requerido"],
      valid: true,
      notification: "",

      focus: null,
      type: "day",
      start: new Date(),
      end: new Date(),
      typeToLabel: {
        month: "Mes",
        week: "Semana",
        day: "Día",
      },
      events: [],
      selectedOpen: false,
      selectedEvent: {
        details: {
          clinicalEvent: {
            patient: {
              person: {
                name: "",
              },
            },
          },
          humanResourceDestination: {
            person: {},
          },
          consultingRoomDestination: {},
        },
      },
      selectedElement: null,
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
        "red",
        "#5cbbf6",
      ],
      //Fin calendario
      sending: false,
      dialog: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      service: ModuleRequest,
      search: "",
      headers: [
        // { text: "#", value: "counter", align: "center" },
        { text: "Id Paciente", value: "patient.idPatient", align: "center",
        width: "10%"

         },
        {
          text: "Nombre del paciente",
          value: "patient.fullNamePatient",
          align: "center",
          width: "20%"
        },
        {
          text: "Servicios asignados",
          value: "specialtyNames",
          align: "center",
        },
        {
          text: "Fecha de solicitud",
          value: "appointmentDate",
          align: "center",
        },
        { text: "Estatus", value: "status", align: "center",           width: "10%"
 },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      encabezado: {
        icono: "mdi-book-edit",
        texto: "Somatometría",
      },
      old: "",
      genderName: "",
      oldValidation: 0,
      idBranchOfficeSelected: null,
      cols: "col-md-3 col-xl-3 col-sm-12",
      // nameRoute: 'Somatometria',
      paramsRoute: {},
      dataModal: {},
      dialog2: false,
      reason: "",
      reasonRules: [(v) => !!v || "El motivo de la cancelación es obligatorio"],
      updater: 0,
      questionsCardiovascular:[],
      questionsProstate:[],
      questionsDiabetes: [],
      calculatorsData: [],
      interpretation: [
        {
          scoreRange: "Menos de 7",
          risk: "Riesgo bajo",
          description: "1%",
          minValue: 0,
          maxValue: 6
        },
        {
          scoreRange: "7-11",
          risk: "Riesgo ligeramente elevado",
          description: "4%",
          minValue: 7,
          maxValue: 11
        },
        {
          scoreRange: "12-14",
          risk: "Riesgo moderado",
          description: "17%",
          minValue: 12,
          maxValue: 14
        },
        {
          scoreRange: "15-20",
          risk: "Riesgo alto",
          description: "33%",
          minValue: 15,
          maxValue: 20
        },
        {
          scoreRange: "Más de 20",
          risk: "Riesgo muy alto",
          description: "50%",
          minValue: 21,
          maxValue: 99
        },
      ],
      headersDiabetesResults: [
        {
          text: 'Puntuación total',
          align: 'start',
          value: 'scoreRange',
        },
        { text: 'Riesgo de desarrollar diabetes en los próximos 10 años', value: 'description' },
        { text: 'Interpretación', value: 'risk' },
      ],
      pointsMapping: {
      "ATEL-03": 0,
  "ATEL-04": 2,
  "ATEL-05": 0,
  "ATEL-06": 1,
  "ATEL-07": 2,
  "ATEL-08": 0,
  "ATEL-09": 5,
  "ATEL-10": 0,
  "ATEL-11": 0,
  "ATEL-12": 3,
  "ATEL-13": 5,
  // HIPERPLASIA PROSTATICA mapping
  "ATEL-14": 0,
  "ATEL-15": 1,
  "ATEL-16": 2,
  "ATEL-17": 3,
  "ATEL-18": 4,
  "ATEL-19": 5,
  "ATEL-20": 0,
  "ATEL-21": 1,
  "ATEL-22": 2,
  "ATEL-23": 3,
  "ATEL-24": 4,
  "ATEL-25": 5,
  "ATEL-26": 0,
  "ATEL-27": 1,
  "ATEL-28": 2,
  "ATEL-29": 3,
  "ATEL-30": 4,
  "ATEL-31": 5,
  "ATEL-32": 0,
  "ATEL-33": 1,
  "ATEL-34": 2,
  "ATEL-35": 3,
  "ATEL-36": 4,
  "ATEL-37": 5,
  "ATEL-38": 0,
  "ATEL-39": 1,
  "ATEL-40": 2,
  "ATEL-41": 3,
  "ATEL-42": 4,
  "ATEL-43": 5,
  "ATEL-44": 0,
  "ATEL-45": 1,
  "ATEL-46": 2,
  "ATEL-47": 3,
  "ATEL-48": 4,
  "ATEL-49": 5,
  "ATEL-50": 0,
  "ATEL-51": 1,
  "ATEL-52": 2,
  "ATEL-53": 3,
  "ATEL-54": 4,
  "ATEL-55": 5
    },
    interpretationRanges: [
      { min: 0, max: 6, risk: "1%", interpretation: "Riesgo bajo" },
      { min: 7, max: 11, risk: "4%", interpretation: "Riesgo ligeramente elevado" },
      { min: 12, max: 14, risk: "17%", interpretation: "Riesgo moderado" },
      { min: 15, max: 20, risk: "33%", interpretation: "Riesgo alto" },
      { min: 21, max: Infinity, risk: "50%", interpretation: "Riesgo muy alto" }
    ],
      calculatorsValues:[11],
      disabilityOptions: [],
      patient: {
        hasDisability: null,   
        disabilityType: null,  
      },
      // headersDiabetesPatient: [
      //   {
      //     text: 'Puntuación total',
      //     align: 'start',
      //     value: 'scoreRange',
      //   },
      //   { text: 'Riesgo de desarrollar diabetes en los próximos 10 años"', value: 'description' },
      //   { text: 'Interpretación', value: 'risk' },
      // ],
    };
  },
  computed: {
  nameRoute() {
    if (this.$utilFront.getRole() === "Enfermería") {
      return "Somatometria";
    }
    return null;
  },

  filteredCalculators() {
  return this.calculatorsData.filter((calculator) => {
    if (calculator.idCalculator === "ETEL-02") {
      if (this.oldValidation < 44) {
        return false;
      }
    }

    if (calculator.idCalculator === "ETEL-03") {
      if (this.genderName !== "Masculino" || this.oldValidation < 40) {
        return false;
      }
    }
    return true;
  });
},

hasIncompleteCalculators() {
    return this.filteredCalculators.some(calculator =>
      calculator.dataQuestions.some(q => {
        if (q.typeAnswer === 2)    return !q.answerClosed;  
        if (q.typeAnswer === 1)    return !q.answerOpen;    
        return false;
      })
    );
  },

  canSaveSomatometry() {
    return !this.hasIncompleteCalculators;
  },
  
  agePoints() {
    if (this.oldValidation < 45) {
      return 0;
    } else if (this.oldValidation <= 54) {
      return 2;
    } else if (this.oldValidation <= 64) {
      return 3;
    } else {
      return 4;
    }
  },
  
  imcPoints() {
    const imc = parseFloat(this.vitalSign[3]) || 0;
    if (imc < 25) {
        return 0;
      } else if (imc <= 30) { 
        return 1;
      } else {
        return 3;
      }
  },

  abdominalPoints() {
    const measure = parseFloat(this.vitalSign[11]) || 0;
    
    if (this.genderName === "Masculino") {
    
      if (measure < 94) {
        return 0;
      } else if (measure <= 102) {
        return 3;
      } else {
        return 4;
      }
    } else if (this.genderName === "Femenino") {
     
      if (measure < 80) {
        return 0;
      } else if (measure <= 88) {
        return 3;
      } else {
        return 4;
      }
    } else {
      return 0;
    }
  },

  totalPoints() {
    const questionPoints = this.filteredCalculators[0].dataQuestions.reduce(
      (sum, question) => {
        const selectedAnswer = question.answerClosed; 
        const points = this.pointsMapping[selectedAnswer] || 0; 
        return sum + points;
      },
      0
    );

    return questionPoints + this.agePoints + this.imcPoints + this.abdominalPoints;
  },

  riskData() {
    return this.interpretationRanges.find(
      (range) => this.totalPoints >= range.min && this.totalPoints <= range.max
    );
  },
  riskPercentage() {
    return this.riskData ? this.riskData.risk : "N/A";
  },
  riskInterpretation() {
    return this.riskData ? this.riskData.interpretation : "N/A";
  }
},
  mounted() {
    this.listAll();
  },
  methods: {
    checkTypetoAssignValidation(vitalsign) {
      switch (vitalsign.label) {
        case "Temperatura":
          return "required|temp";
        case "Frecuencia Cardíaca":
          return "required|heartRate";
        case "Saturación de oxigeno":
          return "required|satuO";
        case "Circunferencia abdominal":
          return "required|hip";
        case "Frecuencia Respiratoria":
          return "required|breathRate";
        case "Talla":
          return "required|size";
        case "Presión Arterial":
          return "required";
        case "Peso":
          return "required|min_value:1|max_value:400";
        case "IMC":
          return "required";
        case "Estado de peso corporal":
          return "required";
      }
    },
    catchError: (e, x) => {
      UtilFront.errorhttp(e);
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.model = {};
        this.action = action;
      } else {
        this.action = action;
      }
    },
    doAction() {
      switch (this.action) {
        case 2:
          this.add();
          break;
        case 3:
          this.update();
          break;
        default:
          break;
      }
    },
    listAll() {
      this.sending = true;
      this.events = [];
      this.list = [];
      let params = {
        idBranchOffice: this.$utilFront.nonEmpty(
          this.idBranchOfficeSelected,
          this.$utilFront.getIdBranchOffice()
        ),
      };

      AppointmentRequest.listPending(params)
        .then((response) => {
          let { data } = response.data;
          this.list = data.map((appointment) => {
            let color = "";
            let status = "";
            switch (appointment.appointmentStatus) {
              case 1:
                color = this.colors[5];
                status = "Pendiente";
                break;
              case 2:
                color = this.colors[0];
                status = "Reprogramado";
                break;
              case 3:
                color = this.colors[4];
                status = "Atendido";
                break;
              case 4:
                color = this.colors[7];
                status = "Cancelado";
                break;
              case 5:
                color = this.colors[6];
                status = "No presentó";
                break;
              case 6:
                color = this.colors[8];
                status = "Presente";
                break;
              case 7:
                color = this.colors[1];
                status = "Pendiente por atender";
                break;
              default:
                break;
            }

            return {
              appointmentDate: this.$utilFront.formatDate(
                appointment.appointmentDate
              ),
              appointmentStatus: appointment.appointmentStatus,
              appointmentIds: appointment.appointmentIds,
              status: status,
              patient: {
                idPatient: appointment.idPatient,
                idPerson: appointment.idPerson,
                birthDate: appointment.birthDate,
                curp: appointment.curp,
                gender: appointment.gender,
                fullNamePatient: appointment.fullNamePatient,
              },
              specialtyNames: appointment.specialtyNames,
              color: color,
              timed: true,
              isValid: true,
            };
          });
        })
        .finally(() => {
          this.sending = false;
        });
    },
    getEventColor(event) {
      return event.color;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    viewDay(date) {
      if (date) {
        this.focus = date;
        this.type = "day";
      } else {
        this.focus = new Date();
        this.type = "day";
      }
    },
    notificarLlegada(item) {
      this.dataModal = Object.assign(item, {});
      this.dialogNotification = true;
      this.selectedOpen = false;
    },
    checkNotification(item) {
      return (
        item.status === "Atendido" ||
        item.status === "Cancelado" ||
        item.status === "Reprogramado" ||
        item.status === "No presentó" ||
        item.status === "Presente" ||
        item.status === "Pendiente por atender"
      );
    },
    getDate(date, action, speciality) {
      let dataDate = date;

      if (action === "REPROGRAMAR") {
        this.$router.push({
          name: "ReprogramarCita",
          params: {
            date: dataDate,
          },
        });
      } else if (action === "MODIFICAR") {
        this.$router.push({
          name: "EditarCita",
          params: {
            date: dataDate.idAppointment,
            speciality: speciality,
          },
        });
      } else if (action === "ATENDER") {
        this.$router.push({
          name: "AtenderConsulta",
          params: { idAppointment: dataDate.idAppointment },
        });
      } else if (action === "VITALES") {
        this.$router.push({
          name: "Interrogatorio",
        });
      }
    },
    getIdAppointment(idAppointment) {
      this.dialogCancelDate = true;
      this.idAppointment = idAppointment;
    },
    notificarLlegadaSend() {
      if (!this.sending) {
        this.sending = true;
        let params = {
          appointmentIds: this.dataModal.appointmentIds,
          notification: this.notification,
        };

        AppointmentRequest.notificationAppointment(params)
          .then((response) => {
            let { data, code } = response.data;
            if (code === 200) {
              this.dialogNotification = false;
              this.$utilFront.notifications(
                "Cita notificada correctamente",
                "SUCCESS"
              );
              this.listAll();
              this.dataModal = {};
            } else {
              this.$utilFront.notifications(
                data || "Error al notificar de llegada",
                "ERROR"
              );
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    //inicio signos vitales
    vitalSigns(selectedEvent) {
      this.vitalSign = {};
      this.selectedEvent = selectedEvent;
      this.selectedOpen = false;
      this.appointment = selectedEvent.idAppointment;
      this.patient = selectedEvent.patient;

      this.old = this.$utilFront.obtainAgeWithLabel(this.patient.birthDate);

      this.oldValidation = this.$utilFront.obtainAge(this.patient.birthDate);

      let gender = this.patient.gender;
      let sex;
      if (gender === "H") {
        sex = "Masculino";
      } else if (gender === "M") {
        sex = "Femenino";
      } else if (gender === "X") {
        sex = "No binario";
      }
      // this.genderName = gender === "M" ? "Femenino" : "Masculino";
      (this.genderName = sex), (this.idPerson = this.patient.idPerson);
      this.changeAction(2);
      this.getVitalSigns();
      this.getAntecentsByPerson();
      this.getCalculator([9, 10, 11]);
      this.getAllDisabilities();
      // this.getCalculatorsSomatometry();
    },
    getVitalSigns() {
      this.sending = true;
      this.inputsVitalSign = [];

      TypeVitalSignRequest.listAllTypeVitalSign()
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.inputsVitalSign = res.data.data.map((input) => {
              let type = "";
              if (input.type === 1) {
                type = "number";
              } else if (input.type === 2) {
                type = "text";
              }

              let required = 0;
              if (input.required === 1) {
                required = true;
              } else if (input.required === 0) {
                required = false;
              }

              return {
                idVitalSignType: input.idVitalSignType,
                type: type,
                label: input.name,
                suffix: input.suffix,
                status: input.status,
                required: required,
              };
            });
          }
        })
        .finally(() => {
          this.sending = false;
          this.changeValidation(this.oldValidation);
        });
    },
    calculateIMC() {
      let talla = 0;

      let imc = 0;

      let clasificacion = "";

      if (this.oldValidation >= 18) {
        if (this.vitalSign[1]) {
          talla = this.vitalSign[1] / 100;
        }

        if (this.vitalSign[2]) {
          imc = this.vitalSign[2] / Math.pow(talla, 2);

          imc = parseFloat(imc).toFixed(2);

          if (imc < 18.5) {
            clasificacion = "Insuficiencia ponderal";
          } else if (imc >= 18 && imc < 25) {
            clasificacion = "Normal";
          } else if (imc >= 25 && imc < 30) {
            clasificacion = "Sobrepeso";
          } else if (imc >= 30 && imc < 35) {
            clasificacion = "Obesidad tipo I";
          } else if (imc >= 35 && imc < 40) {
            clasificacion = "Obesidad tipo II";
          } else if (imc >= 40) {
            clasificacion = "Obesidad tipo III";
          }

          this.$set(this.vitalSign, 3, imc);
          this.$set(this.vitalSign, 8, clasificacion);


          this.updater += 1;
        }
      }

      // if (this.vitalSign[1]) {
      //   talla = this.vitalSign[1] / 100;
      // }

      // if (this.vitalSign[2]) {
      //   imc = this.vitalSign[2] / Math.pow(talla, 2);

      //   imc = parseFloat(imc).toFixed(2);
      //   if (imc < parseFloat("18.5").toFixed(2)) {
      //     clasificacion = "Insuficiencia ponderal";
      //   } else if (
      //     imc >= parseFloat("18").toFixed(2) &&
      //     imc < parseFloat("25").toFixed(2)
      //   ) {
      //     clasificacion = "Normal";
      //   } else if (
      //     imc >= parseFloat("25").toFixed(2) &&
      //     imc < parseFloat("30").toFixed(2)
      //   ) {
      //     clasificacion = "Sobrepeso";
      //   } else if (
      //     imc >= parseFloat("30").toFixed(2) &&
      //     imc < parseFloat("35").toFixed(2)
      //   ) {
      //     clasificacion = "Obesidad tipo I";
      //   } else if (
      //     imc >= parseFloat("35").toFixed(2) &&
      //     imc < parseFloat("40").toFixed(2)
      //   ) {
      //     clasificacion = "Obesidad tipo II";
      //   } else if (imc >= parseFloat("40").toFixed(2)) {
      //     clasificacion = "Obesidad tipo III";
      //   }

      //   this.vitalSign[3] = parseFloat(imc).toFixed(2);
      //   this.vitalSign[8] = clasificacion;
      // }
    },
    getAntecentsByPerson() {
      this.sending = true;

      this.pathologicals = [];
      EvaluationRequest.listByPersonAndType({
        type: 2,
        idPerson: this.idPerson,
      })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.pathologicals = data;
            this.panePL = data.map((it, i) => {
              return i;
            });
            setTimeout(
              function () {
                this.panePL = [0];
              }.bind(this),
              1000
            );
          } else {
            this.pathologicals = [];
          }
        })
        .finally(() => {
          this.heredoFamiliar = [];
          EvaluationRequest.listByPersonAndType({
            type: 3,
            idPerson: this.idPerson,
          })
            .then((res) => {
              let { data, response, message } = res.data;
              if (response) {
                this.heredoFamiliar = data;
                this.panelHF = data.map((it, i) => {
                  return i;
                });
                setTimeout(
                  function () {
                    this.panelHF = [0];
                  }.bind(this),
                  1000
                );
              } else {
                this.heredoFamiliar = [];
              }
            })
            .finally(() => {
              this.sending = false;
            });
        });
    },
    saveData() {
  this.$refs.form.validate().then((success) => {
    if (!success) {
      this.$utilFront.notifications(
        "Verifique que los campos requeridos no estén vacíos",
        "ERROR"
      );
      return;
    }

    if (!this.sending) {
      this.sending = true;
      let idPatient = this.patient.idPatient;

      let objVitalSign = [];
      for (const key in this.vitalSign) {
        let obj = {
          description: this.vitalSign[key],
          vitalSignType: { idVitalSignType: key },
        };
        objVitalSign.push(obj);
      }

      let postVitalSign = {
        patient: { idPatient: idPatient },
        vitalSigns: objVitalSign,
        appointmentIds: this.selectedEvent.appointmentIds,
      };

      let saved = false;

      VitalSignRequest.addVitalSign(postVitalSign)
        .then((res) => {
          saved = res.data.code === 200;
          if (!saved) {
            this.$utilFront.notifications("Error al registrar signos vitales", "ERROR");
          }
        })
        .finally(() => {
          let evaluations = this.pathologicals.concat(this.heredoFamiliar);
          let data = {
            evaluations: evaluations,
            idPerson: this.idPerson,
            disability:
              this.patient.hasDisability === "1"
                ? this.patient.disabilityType 
                : 1, 
          };

          EvaluationRequest.saveEvaluations(data)
            .then((res) => {
              let { response, message } = res.data;
              saved = saved && response;
              if (!response) {
                this.$utilFront.notifications(
                  message || "Error al guardar los antecedentes",
                  "ERROR"
                );
              }
            })
            .finally(() => {
              let calculatorsPayload = {
                calculators: this.calculatorsData.map((calculator) => {
                  let dataQuestions = calculator.dataQuestions
                    .filter((question) => question.answerClosed)
                    .map((question) => ({
                      idQuestion: question.idQuestion,
                      idAnswer: question.answerClosed,
                    }));
                  return {
                    idCalculator: calculator.idCalculator,
                    score: this.getCalculatorScore(calculator),
                    dataQuestions: dataQuestions,
                  };
                }),
                idPerson: this.idPerson,
                appointments: this.selectedEvent.appointmentIds || [],
                idClinicalEvent: null,
              };

              if (
                !calculatorsPayload.calculators.some(
                  (calc) => calc.dataQuestions.length
                )
              ) {
                this.$utilFront.notifications(
                  "Debe completar al menos una calculadora con respuestas.",
                  "ERROR"
                );
                this.sending = false;
                return;
              }

              CalculatorsSomatometryRequest.saveCalculatorsSomatometry(calculatorsPayload)
                .finally(() => {
                  this.sending = false;
                  if (saved) {
                    this.$utilFront.notifications("Información registrada", "SUCCESS");
                    this.listAll();
                    this.changeAction(1);
                  }
                });
            });
        });

      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    }
  });
},

    //Fin signos vitales

    changeValidation(old) {
      for (const key in this.inputsVitalSign) {
        if (old < 18) {
          if (this.inputsVitalSign[key].label === "IMC") {
            this.inputsVitalSign[key].required = false;
          }
          if (this.inputsVitalSign[key].label === "Estado de peso corporal") {
            this.inputsVitalSign[key].required = false;
          }
        } else if (old >= 18) {
          if (this.inputsVitalSign[key].label === "IMC") {
            this.inputsVitalSign[key].required = true;
          }
          if (this.inputsVitalSign[key].label === "Estado de peso corporal") {
            this.inputsVitalSign[key].required = true;
          }
        }
      }
    },

    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAll();
    },
    checkCancel(item) {
      let sexG;
      if (item.patient.gender === "H") {
        sexG = "Masculino";
      } else if (item.patient.gender === "M") {
        sexG = "Femenino";
      } else if (item.patient.gender === "X") {
        sexG = "No binario";
      }
      let info = {
        idPatient: item.patient.idPatient,
        appointmentIds: item.appointmentIds,
        // sex: item.patient.gender == "M" ? "Femenino" : "Masculino",
        sex: sexG,
        birthDate: moment(item.patient.birthDate).format("DD-MM-YYYY"),
        fullNamePatient: item.patient.fullNamePatient,
      };
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, info);
      if (this.$utilFront.isNonNull(this.dataModal)) {
        this.dialog2 = true;
      }
    },
    closeCancel() {
      //this.dataModal = {}
      this.$refs.formCancel.reset();
      this.dialog2 = false;
      this.reason = "";
    },
    cancelConsultation() {
      if (!this.sending) {
        if (this.$refs.formCancel.validate()) {
          this.sending = true;
          // type: 1  //TYPE 1 CONSULTA, TYPE 2 SOMATOMETRÍA

          let params = {
            reason: this.reason,
            appointmentIds: this.dataModal.appointmentIds,
            idHumanResource: this.$utilFront.getIdHumanResource(),
          };

          AppointmentRequest.cancelAppointmentSomatometry(params)
            .then((response) => {
              let { code, data } = response.data;
              if (code == 200) {
                this.closeCancel();
                this.listAll();
                this.$utilFront.notifications(
                  "Cita cancelada correctamente",
                  "SUCCESS"
                );
              } else {
                this.$utilFront.notifications(
                  data || "Sucedio un error al cancelar la cita",
                  "ERROR"
                );
              }
            })
            .finally(() => {
              this.sending = false;
            });
        }
      }
    },

    getCalculator(evaluationTypes) {
  const payload = {
    evaluationTypes,
    //idPerson: this.idPerson,
    //idClinicalEvent: this.patient?.idPatient ?? null,
  };

  CalculatorsSomatometryRequest.getCalculatorsSomatometry(payload)
    .then((res) => {
      this.calculatorsData = [];

      res.data.forEach((calculator) => {
        this.calculatorsData.push(calculator);
      });
    })
    .catch((error) => {
      console.error("Error:", error);
    });
},

getAgePoints() {
    const age = this.oldValidation || 0;
    if (age < 45) {
      return 0;
    } else if (age <= 54) {
      return 2;
    } else if (age <= 64) {
      return 3;
    } else {
      return 4;
    }
  },

  getImcPoints() {
    const imc = parseFloat(this.vitalSign[3]) || 0;
    if (imc < 25) {
      return 0;
    } else if (imc < 30) {
      return 1;
    } else {
      return 3;
    }
  },

  getAbdominalPoints() {
    const measure = parseFloat(this.vitalSign[11]) || 0;
    const gender = this.genderName || "X";

    if (gender === "Masculino") {
      if (measure < 94) {
        return 0;
      } else if (measure <= 102) {
        return 3;
      } else {
        return 4;
      }
    } else if (gender === "Femenino") {
      if (measure < 80) {
        return 0;
      } else if (measure <= 88) {
        return 3;
      } else {
        return 4;
      }
    } else {
      return 0;
    }
  },

getCalculatorPoints(calculator) {
    const questionPoints = calculator.dataQuestions.reduce((sum, question) => {
      const selectedAnswerId = question.answerClosed;
      const points = this.pointsMapping[selectedAnswerId] || 0;
      return sum + points;
    }, 0);

    let extras = 0;
    
    if (calculator.name === "ESCALA FINDRISC") {
      extras = this.agePoints + this.imcPoints + this.abdominalPoints;
    }
   

    return questionPoints + extras;
  },
  getRiskInterpretation(calculator) {
    const total = this.getCalculatorPoints(calculator);

    const foundRange = this.interpretationRanges.find(
      (range) => total >= range.min && total <= range.max
    );

    if (!foundRange) {
      return {
        riskPercentage: "N/A",
        riskInterpretation: "N/A"
      };
    }

    return {
      riskPercentage: foundRange.risk,
      riskInterpretation: foundRange.interpretation
    };
  },

  getHiperplasiaInterpretation(calculator) {
    const total = this.getCalculatorPoints(calculator);

    if (total >= 1 && total <= 7) {
      return "Leve";
    } else if (total >= 8 && total <= 19) {
      return "Moderada";
    } else if (total >= 20) {
      return "Severa";
    }

    return "N/A";
  },
  getCardioRiskForCalculator(calculator) {
      if (calculator.idCalculator !== "ETEL-02") return 0;

      let isSmoker = false;
      const question = calculator.dataQuestions.find(
        (q) => q.idQuestion === "QTEL-01" 
      );
      if (question && question.answerClosed === "ATEL-01") {
        isSmoker = true;
      }

      let genero = "mujeres";
      if (this.genderName === "Masculino") {
        genero = "hombres";
      }

      const edadRange = this.getAgeRange(this.oldValidation);

      const rawPressure = parseFloat(this.vitalSign[7]) || 120; 
      const pKey = this.normalizePressure(rawPressure); 

      const rawIMC = parseFloat(this.vitalSign[3]) || 20; 
      const imcKey = this.normalizeImc(rawIMC);

      const generoObj = cardioRiskData.datos_generales.find(
        (item) => item.genero === genero
      );
      if (!generoObj) return 0;

      const edadObj = generoObj.datos.find((d) => d.edad === edadRange);
      if (!edadObj) return 0;

      const presionObj = edadObj.presion_arterial.find(
        (pa) => pa.valor === pKey
      );
      if (!presionObj) return 0;

      const imcObj = presionObj.IMC[imcKey];
      if (!imcObj) return 0;

      const smokeKey = isSmoker ? "fumadoras" : "no_fumadoras";

      const finalValue = imcObj[smokeKey];
      if (finalValue === undefined) return 0;

      return finalValue;
    },

    getAgeRange(age) {
      if (age >= 70 && age <= 74) return "70-74";
      if (age >= 65 && age <= 69) return "65-69";
      if (age >= 60 && age <= 64) return "60-64";
      if (age >= 55 && age <= 59) return "55-59";
      if (age >= 50 && age <= 54) return "50-54";
      if (age >= 45 && age <= 49) return "45-49";
      if (age >= 40 && age <= 44) return "40-44";
      return "40-44";
    },
    normalizePressure(p) {
      if (p < 130) return 120;
      if (p < 150) return 140;
      if (p < 170) return 160;
      return 180; 
    },
    normalizeImc(imc) {
      if (imc < 22) return "20";
      if (imc < 27) return "25";
      if (imc < 32) return "30";
      return "35";
    },

    getCalculatorScore(calculator) {
  

  if (calculator.idCalculator === "ETEL-02") {
    
    return this.getCardioRiskForCalculator(calculator);
  } else {
    
    return this.getCalculatorPoints(calculator);
  }
},
getAllDisabilities() {
  EnumRequest.listAllDisability()
    .then((response) => {
      const { code, status, data } = response.data;
      if (code === 200 && status === "OK") {

        this.disabilityOptions = data.filter(
          (item) => item.value !== 1
        );
      } else {
        this.disabilityOptions = [];
      }
    })
    .catch((error) => {
      console.error("Error cargando discapacidades:", error);
      this.disabilityOptions = [];
    });
},
onPatientLoaded(fullData) {
  this.patient = fullData;
  if (this.patient.person?.disability === null) {
    this.patient.hasDisability = null;
    this.patient.disabilityType = null;
  } else if (this.patient.person?.disability !== 1) {
    this.patient.hasDisability = "1";
    this.patient.disabilityType = this.patient.person.disability;
  } else {
    this.patient.hasDisability = "0";
    this.patient.disabilityType = null;
  }
},

  },
};
</script>
<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
